var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.collection
    ? _c("div", { staticClass: "collection-grid" }, [
        _c(
          "div",
          { staticClass: "collection-grid__inner-wrapper" },
          [
            _c("div", { staticClass: "collection-grid__header" }, [
              _c("h2", { staticClass: "collection-grid__title" }, [
                _vm._v(_vm._s(_vm.collection.title))
              ]),
              _c(
                "div",
                { staticClass: "collection-grid__actions" },
                [
                  _c(
                    "base-button",
                    {
                      staticClass: "collection-grid__sort-button",
                      on: {
                        click: function($event) {
                          _vm.activeModalAction = "sort"
                          _vm.$refs.actionsModal.open()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.sortButtonLabel))]
                  )
                ],
                1
              )
            ]),
            _c(
              "div",
              { staticClass: "collection-grid__desktop-filters" },
              [
                _c("h2", { staticClass: "collection-grid__title" }, [
                  _vm._v(_vm._s(_vm.collection.title))
                ]),
                _c("p", { staticClass: "collection-grid__filter-title" }, [
                  _vm._v("Filter by:")
                ]),
                _c(
                  "div",
                  { staticClass: "collection-grid__filters-list" },
                  _vm._l(_vm.allSelectedFilters, function(filter) {
                    return _c(
                      "div",
                      {
                        key: filter,
                        staticClass: "collection-grid__selected-filter"
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "collection-grid__selected-filter-text"
                          },
                          [_vm._v(_vm._s(filter))]
                        ),
                        _c("base-button", {
                          staticClass:
                            "collection-grid__selected-filter-remove",
                          attrs: {
                            label: "Remove " + filter + " filter",
                            icon: "close",
                            "icon-size": "12px"
                          },
                          on: {
                            click: function($event) {
                              return _vm.removeFilter(filter)
                            }
                          }
                        })
                      ],
                      1
                    )
                  }),
                  0
                ),
                _vm.allSelectedFilters.length > 0
                  ? _c(
                      "button",
                      {
                        staticClass: "collection-grid__clear-filters-button",
                        on: { click: _vm.clearAllFilters }
                      },
                      [_vm._v("Clear All")]
                    )
                  : _vm._e(),
                _vm._l(Object.keys(_vm.filters), function(filter) {
                  return _vm.filters[filter].options.length > 0
                    ? _c(
                        "accordion",
                        {
                          key: filter,
                          staticClass: "collection-grid__filter-accordion",
                          attrs: {
                            heading: _vm.filterHeading(filter),
                            selected: ""
                          }
                        },
                        _vm._l(
                          _vm.alphabetizeFilterList(
                            _vm.filters[filter].options
                          ),
                          function(option) {
                            return _c(
                              "label",
                              {
                                staticClass:
                                  "collection-grid__option checkbox-input"
                              },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.filters[filter].selected,
                                      expression: "filters[filter].selected"
                                    }
                                  ],
                                  staticClass: "checkbox-input__input",
                                  attrs: { type: "checkbox" },
                                  domProps: {
                                    value: option,
                                    checked: Array.isArray(
                                      _vm.filters[filter].selected
                                    )
                                      ? _vm._i(
                                          _vm.filters[filter].selected,
                                          option
                                        ) > -1
                                      : _vm.filters[filter].selected
                                  },
                                  on: {
                                    change: function($event) {
                                      var $$a = _vm.filters[filter].selected,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = option,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            _vm.$set(
                                              _vm.filters[filter],
                                              "selected",
                                              $$a.concat([$$v])
                                            )
                                        } else {
                                          $$i > -1 &&
                                            _vm.$set(
                                              _vm.filters[filter],
                                              "selected",
                                              $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1))
                                            )
                                        }
                                      } else {
                                        _vm.$set(
                                          _vm.filters[filter],
                                          "selected",
                                          $$c
                                        )
                                      }
                                    }
                                  }
                                }),
                                _c(
                                  "span",
                                  { staticClass: "checkbox-input__checkbox" },
                                  [
                                    _c("icon", {
                                      staticClass: "checkbox-input__check",
                                      attrs: {
                                        name: "check-white",
                                        size: "8px"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "collection-grid__option-text checkbox-input__label-text"
                                  },
                                  [_vm._v(_vm._s(option))]
                                )
                              ]
                            )
                          }
                        ),
                        0
                      )
                    : _vm._e()
                })
              ],
              2
            ),
            _vm.productsWithTile
              ? _c(
                  "div",
                  { staticClass: "collection-grid__grid" },
                  [
                    _c("div", { staticClass: "collection-grid__grid-header" }, [
                      _c(
                        "p",
                        { staticClass: "collection-grid__product-count" },
                        [_vm._v(_vm._s(_vm.productCountLabel))]
                      ),
                      _c(
                        "label",
                        { staticClass: "collection-grid__sort-select" },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "collection-grid__sort-select-text"
                            },
                            [_vm._v("Sort by:")]
                          ),
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.currentSortMethod,
                                  expression: "currentSortMethod"
                                }
                              ],
                              staticClass: "collection-grid__sort-select-input",
                              on: {
                                change: function($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function(o) {
                                      return o.selected
                                    })
                                    .map(function(o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.currentSortMethod = $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                }
                              }
                            },
                            _vm._l(_vm.sortingOptions, function(option) {
                              return _c(
                                "option",
                                {
                                  key: option.value,
                                  domProps: { value: option.value }
                                },
                                [_vm._v(_vm._s(option.label))]
                              )
                            }),
                            0
                          )
                        ]
                      )
                    ]),
                    _c(
                      "div",
                      { staticClass: "collection-grid__filters-list" },
                      [
                        _vm.allSelectedFilters.length > 0
                          ? _c(
                              "button",
                              {
                                staticClass:
                                  "collection-grid__clear-filters-button",
                                on: { click: _vm.clearAllFilters }
                              },
                              [_vm._v("Clear All")]
                            )
                          : _vm._e(),
                        _vm._l(_vm.allSelectedFilters, function(filter) {
                          return _c(
                            "div",
                            {
                              key: filter,
                              staticClass: "collection-grid__selected-filter"
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "collection-grid__selected-filter-text"
                                },
                                [_vm._v(_vm._s(filter))]
                              ),
                              _c("base-button", {
                                staticClass:
                                  "collection-grid__selected-filter-remove",
                                attrs: {
                                  label: "Remove " + filter + " filter",
                                  icon: "close",
                                  "icon-size": "12px"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.removeFilter(filter)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        })
                      ],
                      2
                    ),
                    _vm.collection
                      ? _c(
                          "transition-group",
                          {
                            staticClass: "row small-up-2 large-up-3 hd-up-4",
                            attrs: { name: "grid-sort-animation", tag: "div" }
                          },
                          _vm._l(_vm.currentPageProducts, function(item) {
                            return _c(
                              "div",
                              {
                                key:
                                  item.tileType === "product" ? item.id : "cta",
                                staticClass: "column",
                                class: { "column-2x": item.tileType === "cta" }
                              },
                              [
                                item.tileType === "product"
                                  ? _c("product-tile", {
                                      attrs: {
                                        product: item,
                                        "tile-color": _vm.tileColor
                                      }
                                    })
                                  : item.tileType === "cta" &&
                                    item.backgroundImage
                                  ? _c("cta-tile", {
                                      attrs: {
                                        title: item.title,
                                        description: item.description,
                                        "btn-text": item.btnText,
                                        "btn-link": item.btnUrl,
                                        "background-image":
                                          item.backgroundImage,
                                        "overlay-opacity": item.overlayOpacity
                                      }
                                    })
                                  : _vm._e()
                              ],
                              1
                            )
                          }),
                          0
                        )
                      : _vm._e()
                  ],
                  1
                )
              : _vm._e(),
            _c(
              "div",
              { staticClass: "collection-grid__pagination" },
              [
                _c("pagination", {
                  attrs: { "total-pages": _vm.numPages },
                  on: { "change-page": _vm.setPage }
                })
              ],
              1
            ),
            _c(
              "modal",
              {
                ref: "actionsModal",
                staticClass: "collection-grid__actions-modal"
              },
              [
                _c("template", { slot: "content" }, [
                  _vm.activeModalAction === "sort"
                    ? _c(
                        "div",
                        { staticClass: "collection-grid__mobile-sort-menu" },
                        [
                          _c(
                            "h3",
                            {
                              staticClass:
                                "collection-grid__mobile-sort-menu-title"
                            },
                            [_vm._v("Sort")]
                          ),
                          _vm._l(_vm.sortingOptions, function(option, index) {
                            return _c(
                              "button",
                              {
                                key: option.label + "__" + index,
                                staticClass:
                                  "collection-grid__mobile-sort-menu-item",
                                on: {
                                  click: function($event) {
                                    _vm.currentSortMethod = option.value
                                    _vm.$refs.actionsModal.close()
                                  }
                                }
                              },
                              [_vm._v(_vm._s(option.label))]
                            )
                          })
                        ],
                        2
                      )
                    : _c(
                        "div",
                        { staticClass: "collection-grid__mobile-filter-menu" },
                        [
                          _c(
                            "h3",
                            {
                              staticClass:
                                "collection-grid__mobile-filter-menu-title"
                            },
                            [_vm._v("Filters")]
                          ),
                          _c(
                            "div",
                            {
                              staticClass:
                                "collection-grid__mobile-filter-menu-filters"
                            },
                            _vm._l(Object.keys(_vm.filters), function(filter) {
                              return _vm.filters[filter].options.length > 0
                                ? _c(
                                    "accordion",
                                    {
                                      key: filter,
                                      staticClass:
                                        "collection-grid__filter-accordion",
                                      attrs: {
                                        heading: _vm.filterHeading(filter)
                                      }
                                    },
                                    _vm._l(
                                      _vm.alphabetizeFilterList(
                                        _vm.filters[filter].options
                                      ),
                                      function(option) {
                                        return _c(
                                          "label",
                                          {
                                            staticClass:
                                              "collection-grid__option checkbox-input"
                                          },
                                          [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.filters[filter]
                                                      .selected,
                                                  expression:
                                                    "filters[filter].selected"
                                                }
                                              ],
                                              staticClass:
                                                "checkbox-input__input",
                                              attrs: { type: "checkbox" },
                                              domProps: {
                                                value: option,
                                                checked: Array.isArray(
                                                  _vm.filters[filter].selected
                                                )
                                                  ? _vm._i(
                                                      _vm.filters[filter]
                                                        .selected,
                                                      option
                                                    ) > -1
                                                  : _vm.filters[filter].selected
                                              },
                                              on: {
                                                change: function($event) {
                                                  var $$a =
                                                      _vm.filters[filter]
                                                        .selected,
                                                    $$el = $event.target,
                                                    $$c = $$el.checked
                                                      ? true
                                                      : false
                                                  if (Array.isArray($$a)) {
                                                    var $$v = option,
                                                      $$i = _vm._i($$a, $$v)
                                                    if ($$el.checked) {
                                                      $$i < 0 &&
                                                        _vm.$set(
                                                          _vm.filters[filter],
                                                          "selected",
                                                          $$a.concat([$$v])
                                                        )
                                                    } else {
                                                      $$i > -1 &&
                                                        _vm.$set(
                                                          _vm.filters[filter],
                                                          "selected",
                                                          $$a
                                                            .slice(0, $$i)
                                                            .concat(
                                                              $$a.slice($$i + 1)
                                                            )
                                                        )
                                                    }
                                                  } else {
                                                    _vm.$set(
                                                      _vm.filters[filter],
                                                      "selected",
                                                      $$c
                                                    )
                                                  }
                                                }
                                              }
                                            }),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "checkbox-input__checkbox"
                                              },
                                              [
                                                _c("icon", {
                                                  staticClass:
                                                    "checkbox-input__check",
                                                  attrs: {
                                                    name: "check-white",
                                                    size: "8px"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "collection-grid__option-text checkbox-input__label-text"
                                              },
                                              [_vm._v(_vm._s(option))]
                                            )
                                          ]
                                        )
                                      }
                                    ),
                                    0
                                  )
                                : _vm._e()
                            }),
                            1
                          ),
                          _c(
                            "div",
                            {
                              staticClass:
                                "collection-grid__mobile-filters-menu-actions"
                            },
                            [
                              _c(
                                "base-button",
                                {
                                  staticClass:
                                    "collection-grid__mobile-filters-menu-clear button--outline",
                                  on: { click: _vm.clearAllFilters }
                                },
                                [_vm._v("Clear Filters")]
                              ),
                              _c(
                                "base-button",
                                {
                                  staticClass:
                                    "collection-grid__mobile-filters-menu-apply",
                                  on: {
                                    click: function($event) {
                                      return _vm.$refs.actionsModal.close()
                                    }
                                  }
                                },
                                [_vm._v("Apply")]
                              )
                            ],
                            1
                          )
                        ]
                      )
                ])
              ],
              2
            )
          ],
          1
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }